import { useEffect, useState } from 'react'
import useAppStore from '@/store/useAppStore'
import { TopicViewerEntry } from '@/types/notification'
import { PRESENCE_WINDOW_MS } from '@/utils/constants'

/** How often to re-check the window so stale entries clear themselves without a reload. */
const PRUNE_TICK_MS = 15_000

/**
 * Real-time "who's viewed this topic recently" — driven by the live
 * topic_view socket event (see useWebSocketHook.ts), not a continuous
 * join/leave room. Only ever populated for the topic owner; guests will
 * always see an empty list since the backend never notifies anyone else.
 */
export function useTopicViewers(topicID?: string): TopicViewerEntry[] {
  const allViewers = useAppStore((state) => (topicID ? state.presence.topicViewers[topicID] : undefined))
  const [now, setNow] = useState(() => Date.now())

  useEffect(() => {
    const interval = setInterval(() => setNow(Date.now()), PRUNE_TICK_MS)
    return () => clearInterval(interval)
  }, [])

  if (!allViewers?.length) return []
  return allViewers.filter((v) => now - v.viewedAt < PRESENCE_WINDOW_MS)
}

export default useTopicViewers
